import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enBusiness from './locales/en/business.json';
import enLegal from './locales/en/legal.json';
import enPartner from './locales/en/partner.json';
import enDashboard from './locales/en/dashboard.json';
import enHome from './locales/en/home.json';
import deBusiness from './locales/de/business.json';
import deLegal from './locales/de/legal.json';
import dePartner from './locales/de/partner.json';
import deDashboard from './locales/de/dashboard.json';
import deHome from './locales/de/home.json';

/**
 * App-wide i18n (react-i18next — the standard stack for React SaaS).
 *
 * English is the primary language, German the first secondary. Rollout is
 * incremental by namespace: /business and the legal-page chrome are the
 * first translated surfaces; the rest of the app keeps its hardcoded
 * English strings until each screen is migrated to t() keys. Add a
 * namespace JSON per surface under locales/{lng}/ and register it here.
 *
 * Detection: a ?lang= URL param wins (shareable links — e.g. send clients
 * /business?lang=de or /?lang=en), then explicit user choice (localStorage
 * "okio_lang"), then the browser language; fallback en. The URL param is
 * cached to localStorage, so it sticks as the visitor navigates on.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { business: enBusiness, legal: enLegal, partner: enPartner, dashboard: enDashboard, home: enHome },
      de: { business: deBusiness, legal: deLegal, partner: dePartner, dashboard: deDashboard, home: deHome },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    defaultNS: 'business',
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      lookupLocalStorage: 'okio_lang',
    },
    interpolation: {
      // React already escapes rendered strings
      escapeValue: false,
    },
  });

export default i18n;
